'use client';

import { __styles } from '@griffel/react';
import { typographyStyles } from '@fluentui/react-theme';
export const subtitle1ClassNames = {
  root: 'fui-Subtitle1'
};
/**
 * Styles for the root slot
 */
export const useSubtitle1Styles = /*#__PURE__*/__styles({
  root: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "f1pp30po",
    Bhrd7zp: "fl43uef",
    Bg96gwp: "f106mvju"
  }
}, {
  d: [".fk6fouc{font-family:var(--fontFamilyBase);}", ".f1pp30po{font-size:var(--fontSizeBase500);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".f106mvju{line-height:var(--lineHeightBase500);}"]
});